import { useEffect } from "react";
import { Slide, toast } from "react-toastify";

type ShowConfirmToastParams = {
  title: string;
  message: string;
  btnText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
};

// Overlay helpers
function addOverlay(className = "confirm-toast-overlay") {
  const overlay = document.createElement("div");
  overlay.className = className;
  document.body.appendChild(overlay);
  document.body.style.overflow = "hidden";
  return overlay;
}

function removeOverlay(overlay: HTMLDivElement) {
  if (overlay && overlay.parentNode) {
    overlay.parentNode.removeChild(overlay);
    document.body.style.overflow = "";
  }
}

const ConfirmToast = ({
  title,
  message,
  btnText,
  onConfirm,
  onCancel,
}: ShowConfirmToastParams) => {
  useEffect(() => {
    const overlay = addOverlay();
    return () => {
      removeOverlay(overlay);
    };
  }, []);
  return (
    <div className="confirmWrapper ">
      <h5>{title}</h5>
      <h6>{message}</h6>
      <div className="confirmBtnGroup">
        <button
          className="confirmPlainBtn"
          type="button"
          onClick={() => {
            toast.dismiss();
            if (onCancel) onCancel();
          }}
        >
          Cancel
        </button>
        <button
          className="confirmPrimaryBtn"
          type="button"
          onClick={() => {
            toast.dismiss();
            if (onConfirm) onConfirm();
          }}
        >
          {btnText ? btnText : "Confirm"}
        </button>
      </div>
    </div>
  );
};

// Helper function to show the confirm toast
export const showConfirmToast = ({
  title,
  message,
  btnText,
  onConfirm,
  onCancel,
}: ShowConfirmToastParams): void => {
  toast(
    <ConfirmToast
      title={title}
      message={message}
      btnText={btnText}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />,
    {
      position: "top-center",
      hideProgressBar: true,
      transition: Slide,
      autoClose: false,
      closeOnClick: false,
      rtl: false,
      draggable: false,
      pauseOnHover: true,
      theme: "light",
    }
  );
};
